export const LOGIN = {
  emailInput: "login-email-input",
  passwordInput: "login-password-input",
  submitButton: "login-submit-button",
  googleButton: "login-google-button",
  registerLink: "login-register-link",
};

export const REGISTER = {
  emailInput: "register-email-input",
  passwordInput: "register-password-input",
  nameInput: "register-name-input",
  submitButton: "register-submit-button",
  loginLink: "register-login-link",
};

export const DASHBOARD = {
  container: "dashboard-container",
  createPatientButton: "create-patient-button",
  patientCard: "patient-card",
  logoutButton: "logout-button",
};

export const PATIENT = {
  uploadButton: "patient-upload-button",
  fileInput: "patient-file-input",
  labResultCard: "lab-result-card",
  abnormalValue: "abnormal-value",
};

export const HOME = {
  emergentLink: "emergent-link",
};
